<ng-container *ngIf="materialsLoader$ | async"></ng-container>
<ng-container *ngIf="action$ | async"></ng-container>

<div class="h-full cutting-client-material-list-wrapper flex flex-row items-stretch">
  <div class="material-list-wrapper basis-[350px]">
    <mat-selection-list (selectionChange)="setCurrentMaterial($event.options[0].value)" [multiple]="false">
      <mat-list-option *ngFor="let item of materials" [value]="item">
        {{ getMaterialName(item) }}
      </mat-list-option>
    </mat-selection-list>

    <div *ngIf="materials.length === 0" i18n class="text-center secondary-text h3 mt-6">Материалы не найдены</div>
  </div>

  <div *ngIf="currentMaterial" class="flex-1">
    <div class="flex flex-row p-4 space-x-4">
      <button i18n mat-raised-button (click)="addCutting()" color="accent" [disabled]="disabled">Добавить</button>
      <button
        i18n
        mat-stroked-button
        (click)="addStandardCutting()"
        color="accent"
        [disabled]="disabled"
        *ngIf="showStandardMaterialSizes$ | async"
        >Добавить со склада</button
      >
    </div>

    <mat-divider> </mat-divider>

    <mat-table #table [dataSource]="dataSource" class="client-materials-table" cslEnterLikeTab fusePerfectScrollbar>
      <!-- Height Column -->
      <ng-container cdkColumnDef="height">
        <mat-header-cell i18n *cdkHeaderCellDef>Длина</mat-header-cell>
        <mat-cell class="px-3" *cdkCellDef="let item; let rowIndex = index">
          <mat-form-field class="w-full mini-input no-subscript no-label hidden-outline" appearance="outline">
            <input
              type="number"
              required
              [range]="[0, 10000]"
              number
              matInput
              [(ngModel)]="item.height"
              [disabled]="disabled || item.production || item.standard"
              #heightField="ngModel"
              [matTooltipDisabled]="heightField.valid"
              (ngModelChange)="updateMaterial()"
              [matTooltip]="
                heightField.dirty || heightField.touched ? getError(heightField.errors, 'height', rowIndex) : ''
              "
              onClick="this.select();" />
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <!-- Width Column -->
      <ng-container cdkColumnDef="width">
        <mat-header-cell i18n *cdkHeaderCellDef>Ширина</mat-header-cell>
        <mat-cell class="px-3" *cdkCellDef="let item; let rowIndex = index">
          <mat-form-field class="w-full mini-input no-subscript no-label hidden-outline" appearance="outline">
            <input
              type="number"
              required
              [range]="[0, 10000]"
              number
              matInput
              [(ngModel)]="item.width"
              [disabled]="disabled || item.production || item.standard"
              #widthField="ngModel"
              [matTooltipDisabled]="widthField.valid"
              (ngModelChange)="updateMaterial()"
              [matTooltip]="
                widthField.dirty || widthField.touched ? getError(widthField.errors, 'width', rowIndex) : ''
              "
              onClick="this.select();" />
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <!-- Count Column -->
      <ng-container cdkColumnDef="count">
        <mat-header-cell i18n *cdkHeaderCellDef>Количество</mat-header-cell>
        <mat-cell class="px-3" *cdkCellDef="let item; let rowIndex = index">
          <mat-form-field class="w-full mini-input no-subscript no-label hidden-outline" appearance="outline">
            <input
              type="number"
              required
              [range]="[0, 150]"
              number
              matInput
              [(ngModel)]="item.count"
              [disabled]="disabled || item.production"
              #countField="ngModel"
              [matTooltipDisabled]="countField.valid"
              (ngModelChange)="updateMaterial()"
              [matTooltip]="
                countField.dirty || countField.touched ? getError(countField.errors, 'count', rowIndex) : ''
              "
              onClick="this.select();" />
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <!-- Production Column -->
      <ng-container matColumnDef="production">
        <mat-header-cell i18n *matHeaderCellDef [ngClass]="{ hidden: !hasProduction }">Производственый</mat-header-cell>
        <mat-cell *matCellDef="let item" [ngClass]="{ hidden: !hasProduction }">
          <mat-icon>{{ item.production ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- Square Column -->
      <ng-container matColumnDef="square">
        <mat-header-cell i18n *matHeaderCellDef>Площадь</mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{ getSquare(item) | formatNumber : 2 }}
        </mat-cell>
      </ng-container>

      <!-- Delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let item">
          <button
            mat-icon-button
            enterLikeTabIgnore
            (click)="deleteMaterial(item)"
            [disabled]="disabled || item.production">
            <mat-icon class="mat-24" aria-label="">delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="row-client-material-table"></mat-row>
    </mat-table>
  </div>
</div>
